import {CLOSE_SNACKBAR, OPEN_SNACKBAR} from '../actions'

const snackbarReducer = (state = {snackbarOpen: false, snackbarMessage: ''}, action) => {
	switch(action.type) {
		case CLOSE_SNACKBAR: 
			return Object.assign({}, state, {snackbarOpen: false})
		case OPEN_SNACKBAR: 
			return Object.assign({}, state, {snackbarOpen: true, snackbarMessage: action.message})
		default:
			return state;
	}
}

export default snackbarReducer


// WEBPACK FOOTER //
// ./src/reducers/SnackbarReducer.js